<div class="no-page-found">
    <img class="no-page-found-img" src="assets/images/404.png" alt="">
</div>